/* NaturPeptide theme – progressive enhancement, no dependencies. */
(function () {
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var NP = window.NP || {};

  /* ---------- Header: shadow, hide on scroll down ---------- */
  var hdr = $('[data-hdr]'), lastY = window.scrollY, totop = $('[data-totop]');
  function onScroll() {
    var y = window.scrollY;
    if (hdr) {
      hdr.classList.toggle('is-scrolled', y > 8);
      if (!document.body.classList.contains('is-locked') && !hdr.classList.contains('is-searching') && !hdr.matches(':hover')) {
        if (y > 260 && y > lastY + 4) hdr.classList.add('is-hidden');
        else if (y < lastY - 4 || y < 260) hdr.classList.remove('is-hidden');
      }
    }
    if (totop) totop.classList.toggle('is-on', y > 900);
    lastY = y;
  }
  window.addEventListener('scroll', onScroll, { passive: true }); onScroll();
  if (totop) totop.addEventListener('click', function () { window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' }); });

  /* ---------- Generic drawers (menu, filters) ---------- */
  function setDrawer(el, open) {
    if (!el) return;
    el.classList.toggle('is-open', open);
    el.setAttribute('aria-hidden', open ? 'false' : 'true');
    document.body.classList.toggle('is-locked', open || !!$('.drawer.is-open, .cdrawer.is-open'));
    if (open) { var c = $('[data-drawer-close]', el); if (c) c.focus({ preventScroll: true }); }
  }
  document.addEventListener('click', function (e) {
    var o = e.target.closest('[data-drawer-open]');
    if (o) { e.preventDefault(); setDrawer(document.getElementById(o.getAttribute('data-drawer-open')), true); return; }
    var c = e.target.closest('[data-drawer-close]');
    if (c) { setDrawer(c.closest('.drawer'), false); }
  });

  /* ---------- Accordions: animated <details data-acc> (delegated) ---------- */
  document.addEventListener('click', function (e) {
    var sum = e.target.closest('details[data-acc] > summary');
    if (!sum) return;
    var d = sum.parentElement, body = sum.nextElementSibling;
    if (reduce || !body || !body.animate) { d.classList.toggle('is-open', !d.open); return; }
    e.preventDefault();
    if (d._a) d._a.cancel();
    var opening = !d.open;
    if (opening) d.open = true;
    var h = body.scrollHeight;
    d.classList.toggle('is-open', opening);
    body.style.overflow = 'hidden';
    d._a = body.animate([{ height: (opening ? 0 : h) + 'px', opacity: opening ? 0 : 1 }, { height: (opening ? h : 0) + 'px', opacity: opening ? 1 : 0 }], { duration: Math.min(560, 260 + h * .35), easing: 'cubic-bezier(.22,.8,.26,1)' });
    d._a.onfinish = function () { d._a = null; body.style.overflow = ''; if (!opening) d.open = false; };
  });
  $$('details[data-acc][open]').forEach(function (d) { d.classList.add('is-open'); });

  /* ---------- Reveal on scroll ---------- */
  $$('[data-stagger]').forEach(function (g) { $$(':scope > [data-reveal], :scope > * > [data-reveal]', g).forEach(function (el, i) { el.style.setProperty('--d', i % 8); }); });
  if ('IntersectionObserver' in window && !reduce) {
    var io = new IntersectionObserver(function (en) { en.forEach(function (x) { if (x.isIntersecting) { x.target.classList.add('in'); io.unobserve(x.target); } }); }, { rootMargin: '0px 0px -6% 0px', threshold: .06 });
    $$('[data-reveal]').forEach(function (el) { io.observe(el); });
  } else { $$('[data-reveal]').forEach(function (el) { el.classList.add('in'); }); }

  /* ---------- Announcement rotator ---------- */
  $$('[data-rotator]').forEach(function (r) {
    var msgs = $$('.announce__msg', r), i = 0, ms = parseInt(r.getAttribute('data-speed'), 10) || 5000;
    if (msgs.length < 2 || reduce || r.getAttribute('data-auto') === 'false') return;
    setInterval(function () {
      if (document.hidden) return;
      var cur = msgs[i]; i = (i + 1) % msgs.length; var nx = msgs[i];
      cur.classList.remove('is-on'); cur.classList.add('is-out'); nx.classList.remove('is-out'); nx.classList.add('is-on');
      setTimeout(function () { cur.classList.remove('is-out'); }, 650);
    }, ms);
  });

  /* ---------- Hero slideshow ---------- */
  $$('[data-hero]').forEach(function (h) {
    var slides = $$('.hero__slide', h), dots = $$('.hero__dot, .nh__tab', h), texts = $$('.nh__txt', h), i = 0, timer = null;
    var auto = h.getAttribute('data-auto') === 'true' && slides.length > 1 && !reduce, ms = parseInt(h.getAttribute('data-speed'), 10) || 6000;
    h.style.setProperty('--speed', ms + 'ms');
    function go(n) {
      slides[i].classList.remove('is-on'); if (texts[i]) texts[i].classList.remove('is-on'); if (dots[i]) { dots[i].classList.remove('is-on'); dots[i].setAttribute('aria-current', 'false'); }
      i = (n + slides.length) % slides.length;
      slides[i].classList.add('is-on'); if (texts[i]) texts[i].classList.add('is-on'); if (dots[i]) { void dots[i].offsetWidth; dots[i].classList.add('is-on'); dots[i].setAttribute('aria-current', 'true'); }
      restart();
    }
    function restart() { clearTimeout(timer); if (auto && !h.classList.contains('is-paused')) timer = setTimeout(function () { go(i + 1); }, ms); }
    dots.forEach(function (d, k) { d.addEventListener('click', function () { go(k); }); });
    var p = $('[data-hero-prev]', h), n = $('[data-hero-next]', h);
    if (p) p.addEventListener('click', function () { go(i - 1); });
    if (n) n.addEventListener('click', function () { go(i + 1); });
    h.addEventListener('mouseenter', function () { h.classList.add('is-paused'); clearTimeout(timer); });
    h.addEventListener('mouseleave', function () { h.classList.remove('is-paused'); restart(); });
    var sx = null;
    h.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
    h.addEventListener('touchend', function (e) { if (sx === null) return; var dx = e.changedTouches[0].clientX - sx; if (Math.abs(dx) > 40) go(i + (dx < 0 ? 1 : -1)); sx = null; });
    document.addEventListener('visibilitychange', function () { if (document.hidden) clearTimeout(timer); else restart(); });
    restart();
  });

  /* ---------- Tabs (product tabs) with sliding ink ---------- */
  $$('[data-tabs]').forEach(function (w) {
    var tabs = $$('[data-tab]', w), panels = $$('[data-panel]', w), ink = $('.tabs__ink', w), more = $('[data-tab-more]', w);
    function place(t) { if (!ink || !t) return; ink.style.width = t.offsetWidth + 'px'; ink.style.transform = 'translateX(' + t.offsetLeft + 'px)'; }
    function pick(k) {
      tabs.forEach(function (t, n) { t.classList.toggle('is-on', n === k); t.setAttribute('aria-selected', n === k ? 'true' : 'false'); });
      panels.forEach(function (p, n) { p.classList.toggle('is-on', n === k); p.hidden = n !== k; });
      place(tabs[k]);
      if (more && tabs[k].getAttribute('data-url')) more.href = tabs[k].getAttribute('data-url');
      var tr = panels[k] && $('[data-track]', panels[k]); if (tr) { tr.scrollLeft = 0; tr.dispatchEvent(new Event('scroll')); }
    }
    tabs.forEach(function (t, k) { t.addEventListener('click', function () { pick(k); }); });
    window.addEventListener('resize', function () { place($('[data-tab].is-on', w)); }, { passive: true });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { place($('[data-tab].is-on', w)); });
    place($('[data-tab].is-on', w));
  });

  /* ---------- Clamp long collection descriptions ---------- */
  $$('[data-more]').forEach(function (m) {
    var body = $('.cdesc__body', m), btn = $('[data-more-btn]', m), LIM = 190;
    if (!body || !btn || body.scrollHeight <= LIM + 70) return;
    m.classList.add('is-clamped'); btn.hidden = false; body.style.maxHeight = LIM + 'px';
    var label = $('span', btn), more = label.textContent;
    btn.addEventListener('click', function () {
      var open = !m.classList.contains('is-open');
      m.classList.toggle('is-open', open); m.classList.toggle('is-clamped', !open);
      body.style.maxHeight = open ? body.scrollHeight + 'px' : LIM + 'px';
      label.textContent = open ? (NP.t.less || '−') : more;
    });
  });

  /* ---------- Soft parallax ---------- */
  var px = $$('[data-parallax]');
  if (px.length && !reduce) {
    var tick = false;
    var runPx = function () {
      tick = false;
      var vh = window.innerHeight;
      px.forEach(function (el) {
        var r = el.parentElement.getBoundingClientRect();
        if (r.bottom < -100 || r.top > vh + 100) return;
        var k = parseFloat(el.getAttribute('data-parallax')) || .08;
        el.style.transform = 'translate3d(0,' + ((r.top + r.height / 2 - vh / 2) * -k).toFixed(1) + 'px,0) scale(' + (1 + k * 1.6).toFixed(3) + ')';
      });
    };
    window.addEventListener('scroll', function () { if (!tick) { tick = true; requestAnimationFrame(runPx); } }, { passive: true });
    runPx();
  }

  /* ---------- Carousels with arrows ---------- */
  $$('[data-carousel]').forEach(function (c) {
    var track = $('[data-track]', c), prev = $('[data-prev]', c), next = $('[data-next]', c);
    if (!track) return;
    function step() { var f = track.firstElementChild; return f ? f.getBoundingClientRect().width + (parseFloat(getComputedStyle(track).columnGap) || 0) : track.clientWidth; }
    function upd() { var max = track.scrollWidth - track.clientWidth - 2; if (prev) prev.disabled = track.scrollLeft <= 2; if (next) next.disabled = track.scrollLeft >= max; }
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    track.addEventListener('scroll', function () { requestAnimationFrame(upd); }, { passive: true });
    window.addEventListener('resize', upd, { passive: true }); upd();
  });

  /* ---------- Lazy sections: related products ---------- */
  function initCarousel(c) {
    var track = $('[data-track]', c), prev = $('[data-prev]', c), next = $('[data-next]', c);
    if (!track || c._car) return; c._car = 1;
    function step() { var f = track.firstElementChild; return f ? f.getBoundingClientRect().width + (parseFloat(getComputedStyle(track).columnGap) || 0) : track.clientWidth; }
    function upd() { var max = track.scrollWidth - track.clientWidth - 2; if (prev) prev.disabled = track.scrollLeft <= 2; if (next) next.disabled = track.scrollLeft >= max; }
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    track.addEventListener('scroll', function () { requestAnimationFrame(upd); }, { passive: true });
    window.addEventListener('resize', upd, { passive: true }); upd();
  }
  $$('[data-recs]').forEach(function (sec) {
    if (sec.querySelector('.card')) return;
    var load = function () {
      fetch(sec.getAttribute('data-recs')).then(function (r) { return r.text(); }).then(function (t) {
        var n = new DOMParser().parseFromString(t, 'text/html').querySelector('[data-recs]');
        if (n && n.innerHTML.trim()) { sec.innerHTML = n.innerHTML; initCarousel(sec); $$('[data-reveal]', sec).forEach(function (el, i) { el.style.setProperty('--d', i % 4); requestAnimationFrame(function () { el.classList.add('in'); }); }); }
      }).catch(function () {});
    };
    if ('IntersectionObserver' in window) { var o = new IntersectionObserver(function (e) { if (e[0].isIntersecting) { o.disconnect(); load(); } }, { rootMargin: '400px' }); o.observe(sec); } else load();
  });

  /* ---------- Cart ---------- */
  var cd = $('[data-cart-drawer]');
  function setCart(open) {
    if (!cd) return;
    cd.classList.toggle('is-open', open);
    cd.setAttribute('aria-hidden', open ? 'false' : 'true');
    document.body.classList.toggle('is-locked', open || !!$('.drawer.is-open'));
    if (open) { var c = $('.cdrawer__head [data-cart-close]', cd); if (c) c.focus({ preventScroll: true }); }
  }
  function renderCart(sections) {
    var html = sections && sections['cart-drawer'];
    if (html && cd) {
      var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('.cdrawer__panel');
      var oldBar = $('[data-fship]', cd), oldP = oldBar ? oldBar.style.getPropertyValue('--p') : '0%';
      if (fresh) $('.cdrawer__panel', cd).innerHTML = fresh.innerHTML;
      var bar = $('[data-fship]', cd);
      if (bar) { var to = bar.style.getPropertyValue('--p'); bar.style.setProperty('--p', oldP || '0%'); requestAnimationFrame(function () { requestAnimationFrame(function () { bar.style.setProperty('--p', to); }); }); }
    }
    fetch(NP.cart + '.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
      $$('[data-cart-count]').forEach(function (el) { el.textContent = c.item_count; el.setAttribute('data-count', c.item_count); el.classList.remove('bump'); void el.offsetWidth; el.classList.add('bump'); });
    });
  }
  function post(url, body) {
    body.sections = 'cart-drawer'; body.sections_url = window.location.pathname;
    return fetch(url + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); });
  }
  function fly(img) {
    var target = $('[data-cart-open]');
    if (!img || !target || reduce || !document.body.animate || document.body.getAttribute('data-fly') === 'false') return Promise.resolve();
    var a = img.getBoundingClientRect(), b = target.getBoundingClientRect();
    if (!a.width || a.bottom < 0 || a.top > innerHeight) return Promise.resolve();
    var size = Math.min(a.width, a.height, 160);
    var el = document.createElement('div'); el.className = 'fly';
    el.style.cssText = 'left:' + (a.left + a.width / 2 - size / 2) + 'px;top:' + (a.top + a.height / 2 - size / 2) + 'px;width:' + size + 'px;height:' + size + 'px';
    el.innerHTML = '<img alt="" src="' + (img.currentSrc || img.src) + '">';
    document.body.appendChild(el);
    var dx = b.left + b.width / 2 - (a.left + a.width / 2), dy = b.top + b.height / 2 - (a.top + a.height / 2);
    var an = el.animate([{ transform: 'translate(0,0) scale(1)', opacity: 1 }, { transform: 'translate(' + dx * .55 + 'px,' + (dy * .55 - 60) + 'px) scale(.55)', opacity: 1, offset: .55 }, { transform: 'translate(' + dx + 'px,' + dy + 'px) scale(.12)', opacity: .2, borderRadius: '50%' }], { duration: 700, easing: 'cubic-bezier(.5,0,.3,1)' });
    return new Promise(function (res) { an.onfinish = function () { el.remove(); target.classList.remove('bump'); void target.offsetWidth; target.classList.add('bump'); res(); }; });
  }
  function addToCart(items, img) {
    var req = post(NP.cartAdd, { items: items });
    var flight = (cd && cd.classList.contains('is-open')) ? Promise.resolve() : fly(img);
    return Promise.all([req, flight]).then(function (r) {
      renderCart(r[0].sections);
      if (NP.cartType === 'drawer' && cd) setCart(true); else window.location.href = NP.cart;
    });
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-open]') && cd) { e.preventDefault(); setCart(true); return; }
    if (e.target.closest('[data-cart-close]')) { setCart(false); return; }
    var line = e.target.closest('[data-line]');
    if (line && cd && cd.contains(line)) {
      cd.classList.add('is-busy');
      post(NP.cartChange, { line: Number(line.getAttribute('data-line')), quantity: Number(line.getAttribute('data-q')) })
        .then(function (res) { renderCart(res.sections); }).catch(function () {}).finally(function () { cd.classList.remove('is-busy'); });
      return;
    }
    var q = e.target.closest('[data-quick-add]');
    if (!q) return;
    e.preventDefault();
    if (q.classList.contains('is-busy')) return;
    q.classList.add('is-busy');
    var card = q.closest('.card'), pic = card ? $('.card__media img', card) : null;
    addToCart([{ id: Number(q.getAttribute('data-quick-add')), quantity: 1 }], pic).then(function () {
      q.classList.remove('is-busy'); q.classList.add('is-done');
      setTimeout(function () { q.classList.remove('is-done'); }, 1500);
    }).catch(function () { q.classList.remove('is-busy'); window.location.href = q.closest('.card') ? $('a', q.closest('.card')).href : NP.cart; });
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { setCart(false); $$('.drawer.is-open').forEach(function (d) { setDrawer(d, false); }); if (hdr) hdr.classList.remove('is-searching'); } });

  /* ---------- Product form: variants, quantity, gallery ---------- */
  $$('[data-product]').forEach(function (root) {
    var data = null; try { data = JSON.parse($('[data-product-json]', root).textContent); } catch (err) { return; }
    var form = $('[data-product-form]', root), idInput = form ? $('[name="id"]', form) : null, btn = $('button[type="submit"]', root);
    var qty = $('input[name="quantity"]', root), priceEl = $('[data-price]', root), sticky = $('[data-sticky-buy]');
    function current() {
      var picks = $$('[data-opt]', root).map(function (g) { var c = $('input:checked', g) || $('select', g); return c ? c.value : null; });
      return data.variants.find(function (v) { return v.options.every(function (o, k) { return picks[k] === null || picks[k] === o; }); });
    }
    function money(c) { try { return new Intl.NumberFormat(document.documentElement.lang || 'lt', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR' }).format(c / 100); } catch (e) { return (c / 100).toFixed(2); } }
    function update() {
      var v = current();
      if (!v) { if (btn) { btn.disabled = true; btn.querySelector('span').textContent = NP.t.unavailable || NP.t.soldOut; } return; }
      if (idInput) idInput.value = v.id;
      if (btn) { btn.disabled = !v.available; btn.querySelector('span').textContent = v.available ? NP.t.add : NP.t.soldOut; }
      if (priceEl) {
        var sale = v.compare_at_price && v.compare_at_price > v.price;
        priceEl.className = 'price' + (sale ? ' price--sale' : '');
        priceEl.innerHTML = '<span>' + money(v.price) + '</span>' + (sale ? '<s>' + money(v.compare_at_price) + '</s>' : '');
        $$('[data-sticky-price]').forEach(function (s) { s.textContent = money(v.price); });
      }
      if (v.featured_media) goTo(v.featured_media.id);
      var u = new URL(window.location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u.toString());
    }
    $$('[data-opt] input, [data-opt] select', root).forEach(function (i) { i.addEventListener('change', update); });
    $$('[data-qty]', root).forEach(function (b) { b.addEventListener('click', function () { if (qty) qty.value = Math.max(1, (parseInt(qty.value, 10) || 1) + Number(b.getAttribute('data-qty'))); }); });
    if (form) form.addEventListener('submit', function (e) {
      if (!window.fetch) return;
      e.preventDefault();
      if (btn) btn.classList.add('is-busy');
      addToCart([{ id: Number(idInput.value), quantity: parseInt(qty ? qty.value : 1, 10) || 1 }], $('.gallery__slide.is-on img, .gallery__slide img', root))
        .catch(function (err) { alertNote(form, (err && (err.description || err.message)) || NP.t.error); })
        .finally(function () { if (btn) btn.classList.remove('is-busy'); });
    });
    $$('[data-sticky-add]').forEach(function (b) { b.addEventListener('click', function () { if (form) form.requestSubmit(); }); });
    var row = $('[data-buy-row]', root);
    if (sticky && row && 'IntersectionObserver' in window) new IntersectionObserver(function (en) { sticky.classList.toggle('is-on', !en[0].isIntersecting && en[0].boundingClientRect.top < 0); }).observe(row);

    /* Gallery */
    var track = $('.gallery__track', root), thumbs = $$('[data-thumb]', root), dots = $$('.gallery__dots span', root), slides = $$('.gallery__slide', root);
    function goTo(mediaId) { var s = slides.find(function (x) { return x.getAttribute('data-media') == mediaId; }); if (s && track) track.scrollTo({ left: s.offsetLeft, behavior: reduce ? 'auto' : 'smooth' }); }
    function mark() {
      if (!track) return;
      var k = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
      slides.forEach(function (s, j) { s.classList.toggle('is-on', j === k); });
      thumbs.forEach(function (t, j) { t.classList.toggle('is-on', j === k); });
      dots.forEach(function (d, j) { d.classList.toggle('is-on', j === k); });
    }
    if (track) {
      track.addEventListener('scroll', function () { requestAnimationFrame(mark); }, { passive: true });
      thumbs.forEach(function (t, j) { t.addEventListener('click', function () { track.scrollTo({ left: slides[j].offsetLeft, behavior: reduce ? 'auto' : 'smooth' }); }); });
      var gp = $('[data-g-prev]', root), gn = $('[data-g-next]', root);
      if (gp) gp.addEventListener('click', function () { track.scrollBy({ left: -track.clientWidth, behavior: 'smooth' }); });
      if (gn) gn.addEventListener('click', function () { track.scrollBy({ left: track.clientWidth, behavior: 'smooth' }); });
      mark();
    }
  });
  function alertNote(form, msg) {
    var n = $('.note--err', form) || document.createElement('p');
    n.className = 'note note--err'; n.textContent = msg; form.appendChild(n);
    setTimeout(function () { n.remove(); }, 5000);
  }

  /* ---------- Header search (predictive) ---------- */
  var sp = $('[data-search-panel]'), sIn = $('[data-search-input]'), sRes = $('[data-search-results]'), sHint = sRes ? sRes.innerHTML : '', sT, sC;
  function setSearch(open) {
    if (!sp || !hdr) return;
    if (open) { sp.hidden = false; requestAnimationFrame(function () { hdr.classList.add('is-searching'); }); setTimeout(function () { sIn.focus({ preventScroll: true }); }, 60); }
    else { hdr.classList.remove('is-searching'); setTimeout(function () { if (!hdr.classList.contains('is-searching')) sp.hidden = true; }, 400); }
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-search-open]') && sp) { e.preventDefault(); setSearch(!hdr.classList.contains('is-searching')); }
    else if (e.target.closest('[data-search-close]')) setSearch(false);
  });
  if (sIn) sIn.addEventListener('input', function () {
    var q = sIn.value.trim(); clearTimeout(sT);
    if (q.length < 2) { sRes.innerHTML = sHint; return; }
    sT = setTimeout(function () {
      if (sC) sC.abort(); sC = 'AbortController' in window ? new AbortController() : null;
      sRes.classList.add('is-loading');
      fetch(NP.search + '?q=' + encodeURIComponent(q) + '&resources[type]=product,article,page&resources[limit]=6&resources[limit_scope]=each&section_id=predictive-search', sC ? { signal: sC.signal } : {})
        .then(function (r) { return r.text(); })
        .then(function (t) { var n = new DOMParser().parseFromString(t, 'text/html').querySelector('#shopify-section-predictive-search'); sRes.innerHTML = n ? n.innerHTML : sHint; })
        .catch(function () {}).finally(function () { sRes.classList.remove('is-loading'); });
    }, 180);
  });

  /* ---------- Language selector: submit on change ---------- */
  $$('[data-lang] select').forEach(function (s) { s.addEventListener('change', function () { s.form.submit(); }); });

  /* ---------- Collection: sort + filter form ---------- */
  $$('[data-sort]').forEach(function (s) { s.addEventListener('change', function () { var u = new URL(window.location.href); u.searchParams.set('sort_by', s.value); u.searchParams.delete('page'); window.location.href = u.toString(); }); });
  $$('[data-filters]').forEach(function (f) {
    f.addEventListener('change', function (e) { if (e.target.type === 'checkbox' && window.innerWidth >= 1100) f.requestSubmit(); });
  });

  /* ---------- Share / copy link ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-copy]');
    if (!b) return;
    var url = b.getAttribute('data-copy');
    if (navigator.share && window.matchMedia('(pointer: coarse)').matches) { navigator.share({ url: url, title: document.title }).catch(function () {}); return; }
    navigator.clipboard && navigator.clipboard.writeText(url).then(function () { var l = $('span', b), old = l.textContent; l.textContent = b.getAttribute('data-copied'); setTimeout(function () { l.textContent = old; }, 1800); });
  });

  /* ---------- Reading progress (articles) ---------- */
  var prog = $('[data-progress]'), art = $('[data-article]');
  if (prog && art) {
    var onP = function () { var r = art.getBoundingClientRect(), total = r.height - innerHeight; var p = total > 0 ? Math.min(1, Math.max(0, -r.top / total)) : 0; prog.style.setProperty('--p', p); };
    window.addEventListener('scroll', onP, { passive: true }); onP();
  }

  /* ---------- Reviews pagination ---------- */
  $$('[data-reviews]').forEach(function (w) {
    var items = $$('.review', w), per = parseInt(w.getAttribute('data-per'), 10) || 6, pager = $('.pager', w.parentElement);
    if (!pager || items.length <= per) return;
    var pages = Math.ceil(items.length / per);
    function show(p) { items.forEach(function (it, k) { it.hidden = Math.floor(k / per) !== p; }); $$('button', pager).forEach(function (b, k) { b.classList.toggle('is-on', k === p); }); }
    pager.innerHTML = '';
    for (var k = 0; k < pages; k++) { var b = document.createElement('button'); b.type = 'button'; b.textContent = k + 1; (function (k) { b.addEventListener('click', function () { show(k); w.scrollIntoView({ behavior: 'smooth', block: 'start' }); }); })(k); pager.appendChild(b); }
    show(0);
  });
})();
